import { render, staticRenderFns } from "./drawingCanvas.vue?vue&type=template&id=a147e8f8&scoped=true&"
import script from "./drawingCanvas.vue?vue&type=script&lang=js&"
export * from "./drawingCanvas.vue?vue&type=script&lang=js&"
import style0 from "./drawingCanvas.vue?vue&type=style&index=0&id=a147e8f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a147e8f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
